
    <div style="display: flex; justify-content: center; padding: 0.5em 1em;">
      <input type="checkbox" id="gtac" [(ngModel)]="isAccepted" (change)="updateGTAC()"/>
      <label for="gtac">
        I accept the <a href="https://about.lilo.global/gtac" target="blank">general terms and conditions</a>.
      </label>
    </div>
  